import { Component, ViewChild } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { ModulesManagerService } from 'src/app/classes/Module/modules-manager.service';
import { ApisAdmin } from '../../../classes/admin/apis/apis-admin';

@Component({
    selector: 'app-api',
    templateUrl: './api.component.html',
    styleUrls: ['./api.component.scss'],
    standalone: false
})
export class ApiComponent  {
  @ViewChild('confirmaction') confirmAlert;
  searchText= ""
  constructor(public manager: ModulesManagerService) { }

  private datas:Array<ApisAdmin> = [
    
  ]

  get Datas() {
    return this.datas.filter((data)=> data.containValue(this.searchText)).sort((data1, data2)=> data1.Id - data2.Id)
  }

  public async Reload() {
    this.searchText = ""
    this.datas = []
    let res = await this.manager.Ws.Send("Admin", "Fetch", {module: "ApiLinks"}, true)
    if (res ) {
      if (res.error) return this.manager.Tool.notify(this.manager.Trad.Parse(res.error))
      this.datas = res.data.map((data)=>{
        let AdminApi = new ApisAdmin(this.manager)
        AdminApi.hydrate(data)
        return AdminApi
      })
    }
  }

  public async confirmContact() {
    this.confirmAlert.presentAlert({
      header: this.manager.Trad.Parse('STR_NEW_CONTACT'),
      message: this.manager.Trad.Parse('STR_NEW_CONTACT_DESCRIPTION'),
      cssClass: 'confirm-delete-alert',
      buttons: [
        {
          text: this.manager.Trad.Parse('STR_DELETE'),
          handler: () => {},
          cssClass: 'delete-button',
        },
        {
          text: this.manager.Trad.Parse('STR_EDIT'),
          handler: () => {},
          cssClass: 'edit-button',
        },
        {
          text: this.manager.Trad.Parse('STR_CLOSE'),
        },
      ],
    })
  }
}
